import { firebaseInstance, tokenInstance } from "./api";

export const refreshToken = async (grant_type, refreshToken) =>
  await tokenInstance.post("", {
    grant_type,
    refreshToken,
  });

export const login = async (email, password) => {
  try {
    const response = await firebaseInstance.post("app/login-user", {
      email,
      password,
    });

    return response;
  } catch (error) {
    console.error("Error during login: ", error);
    throw error;
  }
};
export const loginWithGoogle = async (code) => {
  try {
    const response = await firebaseInstance.post("app/login-user-with-google", {
      code,
    });

    return response;
  } catch (error) {
    console.error("Error during login: ", error);
    throw error;
  }
};

export const forgetPassword = async (email) =>
  await firebaseInstance.post("app/forgot-password", {
    email,
  });
export const changePassword = async (email, oldPassword) =>
  await firebaseInstance.post("app/change-password", {
    email,
    oldPassword,
  });

export const signUp = async (
  email,
  firstName,
  lastName,
  imageUrl,
  dob,
  address,
  phoneNumber,
  userName,
  password,
  gender
) => {
  return await firebaseInstance.post(`app/register-user`, {
    email,
    firstName,
    lastName,
    imageUrl,
    dob,
    address,
    phoneNumber,
    userName,
    password,
    gender,
  });
};

export const sendOtp = async (
  phoneNumber,
  recaptchaToken,
  uid,
  option,
  source
) => {
  return await firebaseInstance.post(`app/send-phone-verification-code`, {
    phoneNumber,
    recaptchaStoken: recaptchaToken,
    uid,
    option,
    source,
  });
};
export const verifyOtp = async (
  sessionInfo,
  code,
  idToken,
  uid,
  phoneNumber,
  source
) => {
  return await firebaseInstance.post(`app/verify-phone-verification-code`, {
    sessionInfo,
    code,
    idToken,
    uid,
    phoneNumber,
    source,
  });
};

export const getRecaptchaInfo = async () => {
  return await firebaseInstance.get(`app/get-recaptcha-info`);
};
